import React from "react";
import { useSelector } from "react-redux";

import { importerSelector } from "../../../../../features/certificateOfOrigin/certificateOfOriginSlice";

function ImporterBodyPart() {
  const importer = useSelector(importerSelector);

  return (
    <div className="bg-light-2 p-3 rounded">
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h6 className="m-0">Importer&apos;s Name</h6>
        <p className="m-0 text-muted">{importer.name || "-"}</p>
      </div>

      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h6 className="m-0">Importer&apos;s Email Address</h6>
        <p className="m-0 text-muted">{importer.email || "-"}</p>
      </div>

      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h6 className="m-0">Importer&apos;s Phone Number</h6>
        <p className="m-0 text-muted">{importer.phoneNumber || "-"}</p>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <h6 className="m-0">Importer&apos;s Address</h6>
        <p className="m-0 text-muted">{importer.address || "-"}</p>
      </div>
    </div>
  );
}

export default ImporterBodyPart;
